export const DEFAULT_AFFIRMATIONS = [
	{
		title: "Do It Anyways",
		subtitle: "Deliberate. Disciplined. Daily.",
	},
	{
		title: "An Essentialist",
		subtitle: "Know Essential. Give Context. Prioritize Ruthlessly.",
	},
	{
		title: "A Class Act",
		subtitle: "First Understand. Appreciate. Isn't that Curious.",
	},
	{
		title: "Calm Like Water",
		subtitle: "Be Present. This too shall pass. Work the problem.",
	},
];
